module.exports = __webpack_public_path__ + "static/media/vehi.8169580b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/vehi.svg
// module id = 1145
// module chunks = 0